$(document).ready(function() {

  var $topSlider = $(".top_slide_main");

  $topSlider.slick({
      arrows: false,
      dots: true,
      centerMode: true,
      variableWidth: true,
      centerPadding: '0px',
      slidesToShow: 1,
      swipeToSlide: true,
      infinite: true,
      responsive: [
          {
              breakpoint: 767,
              settings: {
                  centerMode: false,
                  centerPadding: '0px',
                  variableWidth: false
              }
          }
      ]
  });

  $topSlider.find('img').each(function() {
      if (this.complete) { return; }
      $(this).one('load error', function() {
          $topSlider.slick('setPosition');
      });
  });

  $('.event-slide').slick({
      slidesToShow: 4,
      swipeToSlide: true,
      speed: 800,
      dots: false,
      arrows: true,
      infinite: true,
      responsive: [{
              breakpoint: 767,
              settings: {
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 3
              }
          }
      ]
  });

  $('.ranking-collection').slick({
      slidesToShow: 8.3,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 800,
      dots: false,
      arrows: false,
      infinite: false,
      responsive: [{
              breakpoint: 767,
              settings: {
                  slidesToShow: 4.5
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 4
              }
          }
      ]
  });


  $('.feature-collection').slick({
      slidesToShow: 8.3,
      slidesToScroll: 1,
      speed: 800,
      dots: false,
      arrows: false,
      infinite: false,
      responsive: [{
              breakpoint: 767,
              settings: {
                  slidesToShow: 4.5
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 4
              }
          }
      ]
  });

  $('.ranking-product').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    speed: 800,
    dots: false,
    arrows: true,
    infinite: true,
    responsive: [{
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            arrows: false
        }
    }]
  });
  
  $('.feature-product').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 800,
      dots: false,
      arrows: true,
      infinite: true,
      responsive: [{
          breakpoint: 1000,
          settings: {
              slidesToShow: 2,
              arrows: false
          }
      }]
  });

  $('.campaign_slide').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 800,
      dots: false,
      arrows: true,
      infinite: false,
      responsive: [{
          breakpoint: 1000,
          settings: {
              slidesToShow: 2,
              arrows: false
          }
      }]
  });

  $('.ranking-collection .slide').eq(0).addClass('slide-current');
  $('.ranking-collection .slide').on('click', function(){
    $('.ranking-collection .slide.slide-current').removeClass('slide-current');
    $(this).addClass('slide-current');
  });

  $('.feature-collection .slide').eq(0).addClass('slide-current');
  $('.feature-collection .slide').on('click', function(){
    $('.feature-collection .slide.slide-current').removeClass('slide-current');
    $(this).addClass('slide-current');
  });


});
window.onload = () => {
  
  const t = document.getElementById("burgerMenu");
  if (t) {
      const e = document.getElementById("gnavList"),
          i = document.getElementById("headerArea");
      t.addEventListener("click", () => {
          t.classList.contains("burger") ?
              (t.classList.remove("burger"),
                  t.classList.add("burger--active"),
                  e.classList.remove("gnav"),
                  e.classList.add("gnav--active"),
//                   i.classList.remove("header"),
                  i.classList.add("header--active"),
       			  $('html,body').css('overflow', 'hidden')):
      
              (t.classList.remove("burger--active"),
                  t.classList.add("burger"),
                  e.classList.remove("gnav--active"),
                  e.classList.add("gnav"),
                  i.classList.remove("header--active"),
//                   i.classList.add("header"),
               $('html,body').css('overflow', 'auto'));
      });
  }
  openPage('tab-item-1');
  openPage1('tab-item1-1');
//     Jn("eventSlider", "event-slider-item"),
//         Jn("rankingSlider", "items-slider-item"),
//         Jn("recommendSlider", "items-slider-item");
};

function openPage(pageName) {
  tabcontent = document.getElementsByClassName("ranking-product");
  for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.opacity = "0";
      tabcontent[i].style.visibility = "hidden";
      tabcontent[i].style.height = "0px";
      tabcontent[i].style.marginBottom = "0px";
  }

  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
      tablinks[i].style.borderBottom = "";
  }

  document.getElementById(pageName).style.opacity = "1";
  document.getElementById(pageName).style.visibility = "visible";
  document.getElementById(pageName).style.height = "auto";
  document.getElementById(pageName).style.marginBottom = "30px";
}
function openPage1(pageName) {
tabcontent = document.getElementsByClassName("feature-product");
for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.opacity = "0";
    tabcontent[i].style.visibility = "hidden";
    tabcontent[i].style.height = "0px";
    tabcontent[i].style.marginBottom = "0px";
}

tablinks = document.getElementsByClassName("tablink1");
for (i = 0; i < tablinks.length; i++) {
    tablinks[i].style.borderBottom = "";
}

document.getElementById(pageName).style.opacity = "1";
document.getElementById(pageName).style.visibility = "visible";
document.getElementById(pageName).style.height = "auto";
document.getElementById(pageName).style.marginBottom = "30px";
}
